import React from 'react'
import { FormattedMessage } from 'react-intl'
import { FadeIn } from 'lib/ui'
import { Container } from './styled'

export const NotFound = () => {
  return (
    <Container>
      <FadeIn>
        <div>
          <h2>
            <FormattedMessage id='notFound.title' />
          </h2>
          <p>
            <FormattedMessage id='notFound.description' />
          </p>
        </div>
      </FadeIn>
    </Container>
  )
}
